/**
 * Internal Dependencies
 */
const metadata = {
  name: "long-text",
  supports: {
    editable: true,
    required: true,
    attachment: true,
    description: true,
    placeholder: true,
    defaultValue: true,
    logic: true,
    theme: true
  },
  attributes: {
    minCharacters: {
      type: ["boolean", "number"],
      "default": false
    },
    setMaxCharacters: {
      type: "boolean",
      "default": false
    },
    maxCharacters: {
      type: "number",
      multipleOf: 1
    }
  },
  logicalOperators: ["is", "is_not", "starts_with", "ends_with", "contains", "not_contains"]
};
const {
  name
} = metadata;
export { name, metadata };
//# sourceMappingURL=index.js.map